// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"214":"38167002","618":"c99a4e47","931":"8891c303"}[chunkId] + ".css";
};